import _ from 'lodash';

export class SlideCollection {

    public search: string = '';

    public list: any[] = [];
    public found: any[] = [];

    constructor(list: any[]) {
        this.list = _.map(list, (control, index) => { 
            return { ...control.value, index, invalid: control.invalid, visibility: true };
        });

        this.applySearch();
    }

    applySearch() {
        const { search } = this;
        this.found = _.filter(this.list, option => {
            const name = _.chain(option)
                .get('name', '')
                .lowerCase()
                .value();
            const value = _.chain(search)
                .lowerCase()
                .value();
            return _.includes(name, value);
        });
    }
}